import React from 'react';
import PropTypes from 'prop-types';

const FormTextArea = ({ id, label, value: itemValue, rows }) => {
    const { value = '', onBlur, onChange } = itemValue;
    return(
        <div className="form-item">
            <label htmlFor={id} className="u-visual-hidden">{label}</label>
            <textarea value={value} onBlur={onBlur} onChange={onChange} placeholder={label} className="input-textarea" id={id} rows={rows}  />
        </div>
    );
};

FormTextArea.launchDarklyService = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.object.isRequired
};

export default FormTextArea;